<eaglei-leaflet-layer-header [layer]="this" (activeToggled)="toggleLayer($event)" [hideLegend]="hideLegend"> </eaglei-leaflet-layer-header>

<ng-container *ngIf="isActive">
    <ng-container *ngIf="mapLayer.uiHandle === 'hurricaneTract'">
        <eaglei-hurricane-cone-search *ngIf="isActive"></eaglei-hurricane-cone-search>
        <eaglei-legend [legends]="legend"></eaglei-legend>
    </ng-container>
</ng-container>
